 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import CONTENTS from '@/components/contents'
 import INTRODUCTION from '@/components/introduction'
 import VOL001 from '@/components/vol001'
 import VOL001COPYRIGHT from '@/components/vol001copyright'
 import VOL001ACKNOWLEDGEMENTSANDGRATITUDE from '@/components/vol001acknowledgementsandgratitude'
 import VOL001DEDICATION from '@/components/vol001dedication'
 import VOL001CHAPTER001 from '@/components/vol001chapter001'
 import VOL001CHAPTER002 from '@/components/vol001chapter002'
 import VOL001CHAPTER003 from '@/components/vol001chapter003'
 import VOL001CHAPTER004 from '@/components/vol001chapter004'
 import VOL001CHAPTER005 from '@/components/vol001chapter005'
 import VOL001CHAPTER006 from '@/components/vol001chapter006'
 import VOL001CHAPTER007 from '@/components/vol001chapter007'
 import VOL001CHAPTER008 from '@/components/vol001chapter008'
 import VOL001CHAPTER009 from '@/components/vol001chapter009'
 import VOL001CHAPTER010 from '@/components/vol001chapter010'
 import VOL001CHAPTER011 from '@/components/vol001chapter011'
 import VOL001CHAPTER012 from '@/components/vol001chapter012'
 import VOL001CHAPTER013 from '@/components/vol001chapter013'
 import VOL001CHAPTER014 from '@/components/vol001chapter014'
 import VOL001CHAPTER015 from '@/components/vol001chapter015'
 import VOL001CHAPTER016 from '@/components/vol001chapter016'
 import VOL001CHAPTER017 from '@/components/vol001chapter017'
 import VOL001CHAPTER018 from '@/components/vol001chapter018'
 import VOL001CHAPTER019 from '@/components/vol001chapter019'
 import VOL001CHAPTER020 from '@/components/vol001chapter020'
 import VOL001CHAPTER021 from '@/components/vol001chapter021'
 import VOL001CHAPTER022 from '@/components/vol001chapter022'
 import VOL001CHAPTER023 from '@/components/vol001chapter023'
 import VOL001CHAPTER024 from '@/components/vol001chapter024'
 import VOL001CHAPTER025 from '@/components/vol001chapter025'
 import VOL001CHAPTER026 from '@/components/vol001chapter026'
 import VOL001CHAPTER027 from '@/components/vol001chapter027'
 import VOL001CHAPTER028 from '@/components/vol001chapter028'
 import VOL001CHAPTER029 from '@/components/vol001chapter029'
 import VOL001CHAPTER030 from '@/components/vol001chapter030'
 import VOL001CHAPTER031 from '@/components/vol001chapter031'
 import VOL001CHAPTER032 from '@/components/vol001chapter032'
 import VOL001CHAPTER033 from '@/components/vol001chapter033'
 import VOL001CHAPTER034 from '@/components/vol001chapter034'
 import VOL001CHAPTER035 from '@/components/vol001chapter035'
 import VOL001EPILOGUE from '@/components/vol001epilogue'
 import VOL001AUTHORSREFLECTIONONCHICAGOVOCATIONALSCHOOL from '@/components/vol001authorsreflectiononchicagovocationalschool'
 import VOL002 from '@/components/vol002'
 import VOL002COPYRIGHT from '@/components/vol002copyright'
 import VOL002ACKNOWLEDGMENTS from '@/components/vol002acknowledgments'
 import VOL002DEDICATION from '@/components/vol002dedication'
 import VOL002CHAPTER001 from '@/components/vol002chapter001'
 import VOL002CHAPTER002 from '@/components/vol002chapter002'
 import VOL002CHAPTER003 from '@/components/vol002chapter003'
 import VOL002CHAPTER004 from '@/components/vol002chapter004'
 import VOL002CHAPTER005 from '@/components/vol002chapter005'
 import VOL002CHAPTER006 from '@/components/vol002chapter006'
 import VOL002CHAPTER007 from '@/components/vol002chapter007'
 import VOL002CHAPTER008 from '@/components/vol002chapter008'
 import VOL002CHAPTER009 from '@/components/vol002chapter009'
 import VOL002CHAPTER010 from '@/components/vol002chapter010'
 import VOL002CHAPTER011 from '@/components/vol002chapter011'
 import VOL002CHAPTER012 from '@/components/vol002chapter012'
 import VOL002CHAPTER013 from '@/components/vol002chapter013'
 import VOL002CHAPTER014 from '@/components/vol002chapter014'
 import VOL002CHAPTER015 from '@/components/vol002chapter015'
 import VOL002CHAPTER016 from '@/components/vol002chapter016'
 import VOL002CHAPTER017 from '@/components/vol002chapter017'
 import VOL002CHAPTER018 from '@/components/vol002chapter018'
 import VOL002CHAPTER019 from '@/components/vol002chapter019'
 import VOL002CHAPTER020 from '@/components/vol002chapter020'
 import VOL002CHAPTER021 from '@/components/vol002chapter021'
 import VOL002CHAPTER022 from '@/components/vol002chapter022'
 import VOL002CHAPTER023 from '@/components/vol002chapter023'
 import VOL002CHAPTER024 from '@/components/vol002chapter024'
 import VOL002CHAPTER025 from '@/components/vol002chapter025'
 import VOL002CHAPTER026 from '@/components/vol002chapter026'
 import VOL002CHAPTER027 from '@/components/vol002chapter027'
 import VOL002CHAPTER028 from '@/components/vol002chapter028'
 import VOL002CHAPTER029 from '@/components/vol002chapter029'
 import VOL002CHAPTER030 from '@/components/vol002chapter030'
 import VOL002CHAPTER031 from '@/components/vol002chapter031'
 import VOL002CHAPTER032 from '@/components/vol002chapter032'
 import VOL002CHAPTER033 from '@/components/vol002chapter033'
 import VOL002CHAPTER034 from '@/components/vol002chapter034'
 import VOL002CHAPTER035 from '@/components/vol002chapter035'
 import VOL002CHAPTER036 from '@/components/vol002chapter036'
 import VOL002CHAPTER037 from '@/components/vol002chapter037'
 import VOL002CHAPTER038 from '@/components/vol002chapter038'
 import VOL002CHAPTER039 from '@/components/vol002chapter039'
 import VOL002CHAPTER040 from '@/components/vol002chapter040'
 import VOL002CHAPTER041 from '@/components/vol002chapter041'
 import VOL002CHAPTER042 from '@/components/vol002chapter042'
 import VOL003 from '@/components/vol003'
 import VOL003COPYRIGHT from '@/components/vol003copyright'
 import VOL003ACKNOWLEDGMENTS from '@/components/vol003acknowledgments'
 import VOL003DEDICATION from '@/components/vol003dedication'
 import VOL003QUOTEFROMMAEWEST from '@/components/vol003quotefrommaewest'
 import VOL003PART001 from '@/components/vol003part001'
 import VOL003PART001PROLOGUE from '@/components/vol003part001prologue'
 import VOL003PART001CHAPTER001 from '@/components/vol003part001chapter001'
 import VOL003PART001CHAPTER002 from '@/components/vol003part001chapter002'
 import VOL003PART001CHAPTER003 from '@/components/vol003part001chapter003'
 import VOL003PART001CHAPTER004 from '@/components/vol003part001chapter004'
 import VOL003PART001CHAPTER005 from '@/components/vol003part001chapter005'
 import VOL003PART001CHAPTER006 from '@/components/vol003part001chapter006'
 import VOL003PART001CHAPTER007 from '@/components/vol003part001chapter007'
 import VOL003PART001CHAPTER008 from '@/components/vol003part001chapter008'
 import VOL003QUOTEFROMMARILYNMONROE from '@/components/vol003quotefrommarilynmonroe'
 import VOL003PART002 from '@/components/vol003part002'
 import VOL003PART002CHAPTER009 from '@/components/vol003part002chapter009'
 import VOL003PART002CHAPTER010 from '@/components/vol003part002chapter010'
 import VOL003PART002CHAPTER011 from '@/components/vol003part002chapter011'
 import VOL003PART002CHAPTER012 from '@/components/vol003part002chapter012'
 import VOL003PART002CHAPTER013 from '@/components/vol003part002chapter013'
 import VOL003PART002CHAPTER014 from '@/components/vol003part002chapter014'
 import VOL003PART002CHAPTER015 from '@/components/vol003part002chapter015'
 import VOL003QUOTEFROMROBERTFROST from '@/components/vol003quotefromrobertfrost'
 import VOL003PART003 from '@/components/vol003part003'
 import VOL003PART003CHAPTER016 from '@/components/vol003part003chapter016'
 import VOL003PART003CHAPTER017 from '@/components/vol003part003chapter017'
 import VOL003PART003CHAPTER018 from '@/components/vol003part003chapter018'
 import VOL003PART003CHAPTER019 from '@/components/vol003part003chapter019'
 import VOL003PART003CHAPTER020 from '@/components/vol003part003chapter020'
 import VOL003PART003CHAPTER021 from '@/components/vol003part003chapter021'
 import VOL003PART003CHAPTER022 from '@/components/vol003part003chapter022'
 import VOL003PART003CHAPTER023 from '@/components/vol003part003chapter023'
 import VOL003QUOTEFROMDOUGLASADAMS from '@/components/vol003quotefromdouglasadams'
 import VOL003PART004 from '@/components/vol003part004'
 import VOL003PART004CHAPTER024 from '@/components/vol003part004chapter024'
 import VOL003PART004CHAPTER025 from '@/components/vol003part004chapter025'
 import VOL003PART004CHAPTER026 from '@/components/vol003part004chapter026'
 import VOL003PART004CHAPTER027 from '@/components/vol003part004chapter027'
 import VOL003PART004CHAPTER028 from '@/components/vol003part004chapter028'
 import VOL003PART004CHAPTER029 from '@/components/vol003part004chapter029'
 import VOL003PART004CHAPTER030 from '@/components/vol003part004chapter030'
 import VOL003PART004CHAPTER031 from '@/components/vol003part004chapter031'
 import VOL003PART004CHAPTER032 from '@/components/vol003part004chapter032'
 import VOL003PART004CHAPTER033 from '@/components/vol003part004chapter033'
 import VOL003PART004CHAPTER034 from '@/components/vol003part004chapter034'
 import VOL003PART004CHAPTER035 from '@/components/vol003part004chapter035'
 import VOL003PART004CHAPTER036 from '@/components/vol003part004chapter036'
 import VOL003PART004CHAPTER037 from '@/components/vol003part004chapter037'
 import VOL003PART004CHAPTER038 from '@/components/vol003part004chapter038'
 import VOL003PART004CHAPTER039 from '@/components/vol003part004chapter039'
 import VOL003PART004CHAPTER040 from '@/components/vol003part004chapter040'
 import VOL003PART004CHAPTER041 from '@/components/vol003part004chapter041'
 import VOL003PART004CHAPTER042 from '@/components/vol003part004chapter042'
 import VOL003PART004CHAPTER043 from '@/components/vol003part004chapter043'
 import VOL003PART004CHAPTER044 from '@/components/vol003part004chapter044'
 import VOL003PART004CHAPTER045 from '@/components/vol003part004chapter045'
 import VOL003PART004CHAPTER046 from '@/components/vol003part004chapter046'
 import VOL003KINGOFDURABIA from '@/components/vol003kingofdurabia'
 import VOL003QUEENOFLAHAINA from '@/components/vol003queenoflahaina'
 import VOL003SUGARAINTSOSWEET from '@/components/vol003sugaraintsosweet'
 import VOL003LOVINGMEFORME from '@/components/vol003lovingmeforme'
 import VOL003THEPLEASURESALLMINE from '@/components/vol003thepleasuresallmine'
 import VOL003MYTIMEINTHESUN from '@/components/vol003mytimeinthesun'
 import VOL003QUEENSOFTHECASTLESERIES from '@/components/vol003queensofthecastleseries'
 import VOL003KINGSOFTHECASTLE from '@/components/vol003kingsofthecastle'
 import VOL003KNIGHTSOFTHECASTLE from '@/components/vol003knightsofthecastle'
 import VOL003ABOUTTHEAUTHOR from '@/components/vol003abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/vol001",
 			"name" : "vol001",
 			"component" : VOL001
 		},
 		{
 			"path" : "/vol001copyright",
 			"name" : "vol001copyright",
 			"component" : VOL001COPYRIGHT
 		},
 		{
 			"path" : "/vol001acknowledgementsandgratitude",
 			"name" : "vol001acknowledgementsandgratitude",
 			"component" : VOL001ACKNOWLEDGEMENTSANDGRATITUDE
 		},
 		{
 			"path" : "/vol001dedication",
 			"name" : "vol001dedication",
 			"component" : VOL001DEDICATION
 		},
 		{
 			"path" : "/vol001chapter001",
 			"name" : "vol001chapter001",
 			"component" : VOL001CHAPTER001
 		},
 		{
 			"path" : "/vol001chapter002",
 			"name" : "vol001chapter002",
 			"component" : VOL001CHAPTER002
 		},
 		{
 			"path" : "/vol001chapter003",
 			"name" : "vol001chapter003",
 			"component" : VOL001CHAPTER003
 		},
 		{
 			"path" : "/vol001chapter004",
 			"name" : "vol001chapter004",
 			"component" : VOL001CHAPTER004
 		},
 		{
 			"path" : "/vol001chapter005",
 			"name" : "vol001chapter005",
 			"component" : VOL001CHAPTER005
 		},
 		{
 			"path" : "/vol001chapter006",
 			"name" : "vol001chapter006",
 			"component" : VOL001CHAPTER006
 		},
 		{
 			"path" : "/vol001chapter007",
 			"name" : "vol001chapter007",
 			"component" : VOL001CHAPTER007
 		},
 		{
 			"path" : "/vol001chapter008",
 			"name" : "vol001chapter008",
 			"component" : VOL001CHAPTER008
 		},
 		{
 			"path" : "/vol001chapter009",
 			"name" : "vol001chapter009",
 			"component" : VOL001CHAPTER009
 		},
 		{
 			"path" : "/vol001chapter010",
 			"name" : "vol001chapter010",
 			"component" : VOL001CHAPTER010
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js